/* eslint-disable no-extend-native */
import './itemMainSearch.scss';
import CodeStop from 'components/commons/stops/codeStop/CodeStop';
import ButtonLine from 'components/commons/buttons/buttonLine/ButtonLine';
// import ButtonNavigation from 'components/commons/buttons/buttonNavigation/ButtonNavigation';
import { TYPES_MARKERS } from 'utils/constants';
import { textLengthFormated } from 'utils/utils';
import CodePoi from 'components/commons/stops/codePoi/CodePoi';
import { ReactComponent as IC_FILE } from 'resources/icons/file_line.svg';

Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});

export default function ItemMainSearch({
  title,
  description,
  code,
  onClick,
  onClickNav,
  transportMode,
  type,
  routeColor,
  routeTextColor,
  noNav = false,
}) {
  if (type === TYPES_MARKERS.STOP) {
    return (
      <div className='itemMainSearch'>
        <div className='divicon'>
          {type === TYPES_MARKERS.ROUTE ? (
            <ButtonLine
              code={code}
              name={title}
              routeColor={routeColor}
              routeTextColor={routeTextColor}
              onClick={onClick}
            />
          ) : type === TYPES_MARKERS.POI ? (
            <CodePoi onClick={onClick} categoryId={transportMode} />
          ) : (
            <CodeStop text={code} onClick={onClick} transportMode={transportMode} />
          )}
        </div>
        <div className='itemMainSearch_text' onClick={() => onClick()}>
          <div className='itemMainSearch_textDesc'>{`${title.capitalize()} - ${textLengthFormated(
            description,
            50,
          )}`}</div>
        </div>
        {/* {!noNav &&
        <div className='itemMainSearch_link'>
          {
            type !== TYPES_MARKERS.ROUTE
            ? <ButtonNavigation onClick={()=> onClickNav()} />
            : ''
          }
        </div>} */}
      </div>
    );
  } else {
    return (
      <div className='itemMainSearch' style={type === 'faqs' || type === 'news' ? { alignItems: 'flex-start' } : {}}>
        <div className='divicon'>
          {type === TYPES_MARKERS.ROUTE ? (
            <ButtonLine
              code={code}
              name={title}
              routeColor={routeColor}
              routeTextColor={routeTextColor}
              onClick={onClick}
            />
          ) : type === TYPES_MARKERS.POI || type === 'events'  ? (
            <CodePoi onClick={onClick} categoryId={transportMode} />
          ) : type === TYPES_MARKERS.STOP ? (
            <CodeStop text={code} onClick={onClick} transportMode={transportMode} />
          ): type === 'faqs' ? (
            <IC_FILE style={{verticalAlign: 'text-top'}}/>
          ) : type === 'news' ? (
            <IC_FILE style={{verticalAlign: 'text-top'}}/>
          ) : undefined}
        </div>
        <div className='itemMainSearch_text' onClick={() => onClick()}>
          <div className='itemMainSearch_textDesc'>{`${textLengthFormated(title, 70)}`}</div>
        </div>
        {/* {!noNav &&
        <div className='itemMainSearch_link'>
          {
            type !== TYPES_MARKERS.ROUTE
            ? <ButtonNavigation onClick={()=> onClickNav()} />
            : ''
          }
        </div>} */}
      </div>
    );
  }
}
